/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-11-11 13:15:38
 */
export default {
  path: '/',
  name: 'unionManage',
  component: resolve => require(['@/views/Application.vue'], m => resolve(m.default)),
  hidden: false,
  meta: {
    title: '工会管理',
    icon: 'fa fa-university iconTitle',
    nav: 'org'
  },
  children: [
    {
      path: '/vipmanage/idcardAudit/auditVipDetail/:id/:auditStatus',
      name: '待审核会员详情',
      hidden: true,
      meta: {
        title: '待审核会员详情',
        nav: 'org'
      },
      component: resolve =>
        require(['@/views/union/orgVipManage/WaitAuditVipDetail.vue'], m => resolve(m.default))
    },
    {
      path: '/editVipInfo/:id/:unionId',
      name: '查看会员信息',
      hidden: true,
      meta: {
        title: '查看会员信息',
        nav: 'org'
      },
      component: resolve =>
        require(['@/views/union/orgVipManage/EditVip.vue'], m => resolve(m.default))
    },
    {
      path: '/createVipInfo/:id/:unionId',
      name: '新增会员',
      hidden: true,
      meta: {
        title: '新增会员',
        nav: 'org'
      },
      component: resolve =>
        require(['@/views/union/orgVipManage/EditVip.vue'], m => resolve(m.default))
    },
    {
      path: '/vipmanage/idcardAudit/:auditStatus',
      name: '工会会员身份认证',
      hidden: true,
      meta: {
        title: '工会会员身份认证',
        nav: 'org'
      },
      component: resolve =>
        require(['@/views/union/orgVipManage/VipIDCardAudit.vue'], m => resolve(m.default))
    },
    {
      path: '/addProUnion',
      name: '新建工会',
      hidden: true,
      meta: {
        title: '新建工会',
        nav: 'org',
        role: ['admin', 'levelunion', 'topunion']
      },
      component: resolve => require(['@/views/union/pro/AddProUnion.vue'], m => resolve(m.default))
    },
    {
      path: '/unionDetail/:id',
      name: '查看工会信息',
      hidden: true,
      meta: {
        title: '查看工会信息',
        nav: 'org',
        role: ['admin', 'levelunion', 'topunion']
      },
      component: resolve => require(['@/views/union/pro/UnionDetail.vue'], m => resolve(m.default))
    },
    {
      path: '/manage',
      name: 'unionManage',
      hidden: false,
      meta: {
        title: '工会管理',
        nav: 'org',
        iconClass: 'icon-union',
        role: ['admin', 'levelunion', 'topunion'],
        icon: 'fa fa-university iconTitle'
      },
      component: resolve => require(['@/views/union/manage'], m => resolve(m.default))
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/router-orgment.js